module.exports = __webpack_public_path__ + "img/s1_t1_09.3af53818.jpeg";